var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Have other research needs?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We offer a suite of solutions to help our clients identify, verify and engage with African corporates."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Through an extensive team of in-country analysts, technology and strategic partnerships, we serve a growing number of multinationals, financial institutions, advisories and public agencies."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openSolutions },
          },
          [_vm._v("See Solutions")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }